import React, { Component } from 'react';
import "./index.scss";

class index extends Component {
    render() {
        return (
            <div className="theChart">
                各餐厅餐饮成本率 Restaurant F&B Cost %
                <div id="RestaurantCost" style={{ height: 400, width: '100%' }}></div>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/analysisChart/RestaurantCost.js